package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier


@Composable
internal fun NavigationScope.NavigationSection(
    title: String,
    icon: (@Composable () -> Unit)? = null,
    content: @Composable () -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(Dimens.navNavigationEntriesGap),
    ) {
        NavigationSectionHeader(title, icon, isNavigationCollapsed)
        content()
    }
}

@Composable
private fun NavigationSectionHeader(
    title: String,
    icon: (@Composable () -> Unit)? = null,
    isCollapsed: Boolean,
) {
    Row(
        modifier = NavSectionHeaderStyle.toModifier(),
    ) {
        NavigationItemContent(
            icon = icon ?: {  },
            text = title,
            isCollapsed = isCollapsed,
        )
//        SpanText(
//            title,
//            modifier = NavTextStyle
//                .toModifier(if (isCollapsed) NavTextCollapsedVariant else null)
//        )
    }
}
